import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RetryTransferAPI } from "api/transactionAPI";
import { GetTransactionsByPlaceIdAPI } from "api/transactionAPI";

import { get } from "lodash";

const handleThunkError = (err, rejectWithValue) => {
  return rejectWithValue(
    err?.response?.data || {
      success: false,
      message: "Something went wrong",
    }
  );
};

const initialState = {
  list: [],
  totalTransactions: 0,
  loading: false,
  retrying: false,
  error: null,
};

export const getTransactionsByPlaceId = createAsyncThunk(
  "transactions/getTransactionsByPlaceId",
  async (data,{rejectWithValue}) => {
    try {
      const response = await GetTransactionsByPlaceIdAPI(data);
      return response.data;
    } catch (err) {
      console.log("Get Transactions error ===>", err);
       return handleThunkError(err, rejectWithValue);
    }
  }
);

export const retryTransfer = createAsyncThunk(
  "transactions/retryTransfer",
  async (transferData, { rejectWithValue }) => {
    try {
      const response = await RetryTransferAPI(transferData);
      if (!response.data.success) {
        return rejectWithValue(response.message || "Something went wrong");
      }
      return response.data;
    } catch (err) {
      console.error("Retry Transfer error ===>", err);
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const transactionSlice = createSlice({
  name: "transactions",
  initialState,
  reducers: {
    clearRetryState(state) {
      state.retrying = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTransactionsByPlaceId.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTransactionsByPlaceId.fulfilled, (state, action) => {
        state.list = get(action.payload, "success", false)
          ? action.payload.transactions
          : [];
        state.totalTransactions = get(action.payload, "total", 0);
        state.loading = false;
      })
      .addCase(getTransactionsByPlaceId.rejected, (state) => {
        state.loading = false;
      })
      // retryTransfer
      .addCase(retryTransfer.pending, (state) => {
        state.retrying = true;
        state.error = null;
      })
      .addCase(retryTransfer.fulfilled, (state, action) => {
        const updatedTx = action.payload.transaction;
        state.list = state.list.map((tx) =>
          tx._id === updatedTx._id ? updatedTx : tx
        );
        state.success = true;
        state.retrying = false;
      })
      .addCase(retryTransfer.rejected, (state, action) => {
        const updatedTx = action.payload.transaction;
        state.list = state.list.map((tx) =>
          tx._id === updatedTx._id ? updatedTx : tx
        );
        state.success = false;
        state.retrying = false;
        state.error = action.payload;
      });
  },
});
export const { clearRetryState } = transactionSlice.actions;
export default transactionSlice.reducer;
